import React from "react";
import { RefreshCcw } from "lucide-react";

const RefreshButton = ({ onClick, isLoading, className = "" }) => {
  return (
    <button 
      onClick={onClick}
      disabled={isLoading}
      className={`w-full flex items-center justify-center gap-3 py-3 bg-stone-100 dark:bg-white/5 text-stone-600 dark:text-stone-400 rounded-xl hover:bg-stone-200 dark:hover:bg-white/10 transition-all active:scale-95 border border-stone-200 dark:border-white/10 font-black text-[10px] uppercase tracking-widest disabled:opacity-50 ${className}`}
      title="Refresh Data"
    >
      <RefreshCcw size={18} className={isLoading ? "animate-spin" : ""} />
      <span>Refresh</span>
    </button>
  );
};

export default RefreshButton;